import React from 'react'
import { Avatar } from '@mui/material'
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded'
import { onDark, surfaces } from '../../theme'
import { NEUTRAL_STYLE, styleForCategory } from './feedCategory'

type Props = { name?: string; categoryId?: string | null; group?: boolean; size?: number }

const initialsFor = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('')

const CareTeamAvatar = ({ name = '', categoryId, group, size = 36 }: Props) => {
  if (group) {
    return (
      <Avatar sx={{ width: size, height: size, backgroundColor: surfaces.blue.fg, color: onDark.primary }}>
        <GroupsRoundedIcon sx={{ fontSize: size * 0.55 }} />
      </Avatar>
    )
  }

  const style = categoryId ? styleForCategory(categoryId) : NEUTRAL_STYLE

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.38,
        fontWeight: 600,
        backgroundColor: style.bg,
        color: style.fg,
        border: `1px solid ${style.stroke}`,
      }}
    >
      {initialsFor(name)}
    </Avatar>
  )
}

export default CareTeamAvatar
